var tag = new ATInternet.Tracker.Tag();
tag.page.set({
    level2:'1',
    chapter1: encodeURIComponent('Home'.replace(/&amp;/g,'and').replace(/&/g,'and')),
    chapter2: encodeURIComponent('About us'.replace(/&amp;/g,'and').replace(/&/g,'and')),
    name: encodeURIComponent('Company'.replace(/&amp;/g,'and').replace(/&/g,'and'))


});
tag.customVars.set({
    site: {
        3: '[en]',
        4: '86943',
        6: '1'
    }
});
tag.Scroll.init({});

tag.dispatch();

// $(document).ready(function () {
//     WordCountScript.Do( function( sValue ){
//         tag.publisher.set({
//             impression: {
//                 campaignId : '[Scrollview]',
//                 variant: '[' + sValue + ']'
//             }
//         });


//         // Tracking
//         tag.dispatch();

//     });

// });
